enum FEED_TYPES {
    PROPOSAL = 'proposal',
    DISCUSSION = 'discussion',
}

export { FEED_TYPES };
